import { render } from "./AssistantHeader.vue?vue&type=template&id=ea357d64"
import script from "./AssistantHeader.vue?vue&type=script&lang=js"
export * from "./AssistantHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__